

import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminSamlService} from "../../../../../services/api/admin/admin-saml/admin-saml.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminSamlComponentDialog} from "./admin-saml-create-edit-dialog/admin-saml-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";

@Component({
  selector: 'app-admin-saml',
  templateUrl: './admin-saml.html'
})
export class AdminSamlComponent implements OnInit {

  data;
  isLoading = true;

  constructor(private apiAdminSamlService: ApiAdminSamlService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
    this.getData();
  }

  ngOnInit(): void {
  }

  getData(){
    this.isLoading = true;
    this.apiAdminSamlService.listAll().then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminSamlComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminSamlComponentDialog, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminSamlService.delete(id).then(response => this.getData())
      }, cancelled => null)
  }



}
